export default "__VITE_ASSET__Di0dGr$8__"